module.exports = __webpack_public_path__ + "static/media/blue-report-bg.1d5fa635.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blue-report-bg.png
// module id = 515
// module chunks = 0